import { utils, writeFile } from 'xlsx'
import { AnaliseAmostraTerceiraItem } from './getAnaliseAmostraTerceira'

type ResultadoItem = {
    nomePessoa: string
    tipoMonitoramento: string
    parametros: string[]
}

export default function excelProgramacaoSelecaoEnsTerceiros(
    item: AnaliseAmostraTerceiraItem
): void {
    if (!item.resultado) return

    let linhas: ResultadoItem[] = []

    try {
        const parsed: ResultadoItem[] = JSON.parse(item.resultado)
        if (Array.isArray(parsed)) {
            linhas = parsed.map(r => ({
                nomePessoa: r.nomePessoa,
                tipoMonitoramento: r.tipoMonitoramento,
                parametros: Array.isArray(r.parametros) ? r.parametros : []
            }))
        }
    } catch {
        return
    }

    if (linhas.length === 0) return

    const maxParametros = linhas.reduce(
        (max, linha) => Math.max(max, linha.parametros.length),
        0
    )

    const header = ['Indústria', 'Amostragem frequente']
    for (let i = 1; i <= maxParametros; i++) {
        header.push(`parametro${i}`)
    }

    const linhasParaExcel = linhas.map(linha => {
        const row: any = {
            'Indústria': linha.nomePessoa,
            'Amostragem frequente': linha.tipoMonitoramento
        }

        linha.parametros.forEach((param, index) => {
            row[`parametro${index + 1}`] = param
        })

        return row
    })

    const worksheet = utils.json_to_sheet(linhasParaExcel, { header })
    const workbook = utils.book_new()
    utils.book_append_sheet(workbook, worksheet, 'Programacao')

    const safeName =
        item.nomesClientes?.replace(/[\\/:*?"<>|]/g, '').substring(0, 40) ||
        'programacao'

    writeFile(workbook, `${safeName}_selecao_ens_terceiros.xlsx`)
}
